// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1khEh","selected":"Chip_selected__2Vz7E"};